







































































































































































import Vue from "vue";
import { Task, TaskGroup } from "@/tasks";
import TasksList from "../tasks/TasksList.vue";
import { TaskFilterOption, TaskSortOption } from "../../enums";
import TaskFilter from "../tasks/TasksFilter.vue";
import storeHelper from "../../store/store-helper";
import * as UserApplicationState from "@/userapplicationstate";
import { Constants } from "@/constants";

export default Vue.extend({
    name: "NotificationsTab",
    components: { TasksList, TaskFilter },
    props: {
        notifications: Array as () => Task[],
        team: Boolean,
        isBusy: Boolean
    },
    data: () => {
        return {
            search: "",
            sort: TaskSortOption.DateNewToOld,
            notificationFilterDrawer: false,
            filteredNotifications: [] as Task[],
            filter: TaskFilterOption.My,
            taskgroups: [] as TaskGroup[],
            bus: new Vue()
        };
    },
    async created() {
        storeHelper.subscriptionsStore.loadMySubscriptionsAsync();
        this.sort = await this.getSortOption();
        //Save notifications as last tab
        sessionStorage.setItem(Constants.Task.ApplicationsState.TasksLastTab, "notifications");
        //Set filter group from state
        const notificationFilterGroupOptionState: string | null = await UserApplicationState.get(
            Constants.Task.ApplicationsState.NotificationFilterGroupOption
        );
        if (notificationFilterGroupOptionState) this.taskgroups = JSON.parse(notificationFilterGroupOptionState) as TaskGroup[];
    },
    updated() {
        //Make sure we set on scroll event everytime when updated is called
        this.bus?.$emit("set-on-scroll-event");
    },
    computed: {
        mdAndDownView(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        sortOptions(): string[] {
            const options: Array<string> = [TaskSortOption.DateNewToOld, TaskSortOption.DateOldToNew, TaskSortOption.Important];
            return options;
        },
        selectedFilter(): TaskFilterOption {
            return storeHelper.notificationsStore.selectedFilter;
        },
        hasNotifications(): boolean {
            return this.notifications.length > 0;
        },
        hasFilteredNotifications(): boolean {
            return this.filteredNotifications.length > 0;
        },
        filteredAndSortedNotifications(): Task[] {
            const sorted = [...this.filteredNotifications];
            if (this.sort == TaskSortOption.Important) {
                sorted.sort((a, b) => {
                    const sortValueA = parseFloat(`${a.is_important ? 2 : 1}.${a.last_modified_date_time.getTime()}`);
                    const sortValueB = parseFloat(`${b.is_important ? 2 : 1}.${b.last_modified_date_time.getTime()}`);

                    //descending high value to low value
                    return sortValueB - sortValueA;
                });
            } else if (this.sort == TaskSortOption.DateNewToOld) {
                //date new to old
                sorted.sort((a, b) => {
                    const sortValueA = parseFloat(`${a.last_modified_date_time.getTime()}`);
                    const sortValueB = parseFloat(`${b.last_modified_date_time.getTime()}`);

                    //descending high value to low value
                    return sortValueB - sortValueA;
                });
            } else {
                //date old to new
                sorted.sort((a, b) => {
                    const sortValueA = parseFloat(`${a.last_modified_date_time.getTime()}`);
                    const sortValueB = parseFloat(`${b.last_modified_date_time.getTime()}`);

                    //ascending low value to high value
                    return sortValueA - sortValueB;
                });
            }
            UserApplicationState.set(Constants.Task.ApplicationsState.NotificationSort, this.sort);
            return sorted;
        }
    },
    methods: {
        filterGroupChanged(filterGroup: string[]): void {
            if (filterGroup.length == 0) UserApplicationState.remove(Constants.Task.ApplicationsState.NotificationFilterGroupOption);
            else UserApplicationState.set(Constants.Task.ApplicationsState.NotificationFilterGroupOption, JSON.stringify(filterGroup));
        },
        async getSortOption(): Promise<TaskSortOption> {
            const sortOption = await UserApplicationState.get(Constants.Task.ApplicationsState.NotificationSort);
            return sortOption ? (sortOption as TaskSortOption) : TaskSortOption.DateNewToOld;
        }
    }
});
